import { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { addProductType, getGeneralProductType, uploadProductTypeImage } from "../adminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";

import {
  validateAgeGrp,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import DropdownWithClear from "../../../Component/dropdownWithClear";
const CreateProductType = () => {
  const initialVal: {
    name: string;
    image: any;
    seoName: string;
    order: any;
    imagePreview?: any;
    // productType: any;
  }[] = [
      {
        name: "",
        image: "",
        order: "",
        seoName: "",
        imagePreview: "",
        // productType: "",
      },
    ];
  const dispatch: Function = useDispatch<AppDispatch>();
  const [productArr, setProductArr] = useState<any>(initialVal);
  const [productTypeList, setProductTypeList] = useState<any>([]);

  const onPressAdd = () => {
    const newItem = JSON.parse(JSON.stringify(initialVal[0])); // Deep copy
    setProductArr((prev: any) => [...prev, newItem]);
  };
  const handleClose = (index: number) => {
    setProductArr((prev: any) => prev.filter((_: any, i: any) => i !== index));
  };

  useEffect(() => {
    dispatch(
      getGeneralProductType({
        callback: (res: any) => {
          setProductTypeList(res?.data);
             if (res?.status === "success") {
                      dispatch(showSnackbar({ message: res?. msg, type: res?.status }));
                      setTimeout(() => {
                        hideSnackbar();
                      }, 5000);
                    }
        },
        errorCallback: (error:any) => {
                dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
                    setTimeout(() => {
                      hideSnackbar();
                    }, 5000);
         },
      })
    );
  }, []);


  const onchangeProduct = (val: any, index: number, key: string) => {
    const updatedArr = [...productArr];
    const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    if (key === "image") {
      const file = val?.target?.files?.[0];
      if (!file || !mediaTypes.includes(file.type) || !validateIsFileImageType(val)) {
        console.error("Invalid or unsupported file");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        updatedArr[index]["imagePreview"] = reader.result;
        setProductArr([...updatedArr]);
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadProductTypeImage({
          params: file,
          callback: (res: any) => {
            if (res?.data) {
              updatedArr[index][key] = res?.data?.name;
              setProductArr([...updatedArr]);
            }
          },
          errorCallback: () => {
            console.error("Image upload failed");
          },
        })
      );
    } else if (["name", "seoName"].includes(key)) {
      updatedArr[index][key] = val;
      setProductArr([...updatedArr]);
    } else if (key === "order") {
      if (validateAgeGrp(val)) {
        updatedArr[index][key] = val;
        setProductArr([...updatedArr]);
      }
    }
  };

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const updatedProduct = productArr.map((item: any) => { const { imagePreview, ...rest } = item; return rest });
    const postData = {
      book: updatedProduct,
    };
    dispatch(
      addProductType({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setProductArr([initialVal[0]]);
            dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const validationProductType = () => {
    let ProductTypeFormatArr: boolean = false;
    productArr?.map((item: any) => {
      if (
        item?.image === "" ||
        item?.imagePreview === "" ||
        item?.order === "" ||
        item?.seoName === ""
      ) {
        ProductTypeFormatArr = true;
      }
    });
    return ProductTypeFormatArr;
  };

  const validations: any = () => {
    return validationProductType();
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Create Product Type"} />
      </div>
      <div className="formDiv">
        <form onSubmit={handleSubmit}>
          <div className=" ">
            {productArr.map((item: any, index: any) => {
              return (
                <div className="d-flex">
                  <div className="row bxshadow p-2 borderRadius mb-4 w-100 me-2">
                    <div className="col-md-4 mb-3">
                      <LabelInput labelName={"Product name"} isRequired />
                      <InputField
                        key={"ex2"}
                        placeholder={"Enter Product Name"}
                        setInputText={(value: any) =>
                          onchangeProduct(value, index, "name")
                        }
                        value={item.name}
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <LabelInput labelName={"Order number"} isRequired />
                      <InputField
                        key={"ex2"}
                        placeholder={`Order  No. ${index + 1}`}
                        setInputText={(value: any) =>
                          onchangeProduct(value, index, "order")
                        }
                        value={item.order}
                        maxLength={3}
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <LabelInput labelName={"SEO Name"} isRequired />
                      <InputField
                        key={"ex2"}
                        placeholder={"Enter SEO Name"}
                        setInputText={(value: any) =>
                          onchangeProduct(value, index, "seoName")
                        }
                        value={item?.seoName}
                      />
                    </div>
                    {/* <div className="col-md-4 mb-3">
                      <LabelInput labelName={"Type"} isRequired />
                      <DropdownWithClear
                        labelName={"Select Product Type"}
                        setInputText={(value: any) =>
                          onchangeProduct(value, index, "productType")
                        }
                        options={productTypeList}
                        value={item?.productType}
                      />
                    </div> */}
                    <div className="col-md-2 mb-3">
                      <LabelInput labelName={"Upload Image"} isRequired />
                      <ImagePickerAndViewer
                        value={item?.imagePreview}
                        handleChange={(value: any) => (onchangeProduct(value, index, "image"))}
                        htmlFor={`photo-upload-${index}`}
                        doctype={""} />
                    </div>
                    {index === productArr.length - 1 && (
                      <div className="col-2 py-5">
                        <AddMoreBtn handleClick={onPressAdd} />
                      </div>
                    )}
                  </div>
                  {productArr.length === 1 ? null : (
                    <DeleteForeverIcon
                      className="cursor"
                      color="error"
                      fontSize="small"
                      onClick={() => handleClose(index)}
                    />
                  )}
                </div>
              );
            })}
            <div className="d-flex justify-content-center mt-3">
              <div className="col-2 pt-2">
                <Submitbtn name={"Submit"} disabled={validations()} />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateProductType;
